"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACE_ID_PRODUCT = exports.FLEX_PRODUCT = void 0;
var TRACE_ID_PRODUCT = "traceid";
exports.TRACE_ID_PRODUCT = TRACE_ID_PRODUCT;
var FLEX_PRODUCT = "flex";
exports.FLEX_PRODUCT = FLEX_PRODUCT;